document.addEventListener('DOMContentLoaded', function () {
  // Merchant-authored descriptions put a "Details" line (plus the bullet
  // list that follows it) inline in the rich text. Wrap that line and
  // everything after it in a native <details> so it collapses by default,
  // rather than the whole details block sitting open all the time.
  var descriptionEl = document.querySelector('.product-description');
  if (descriptionEl) {
    var children = Array.prototype.slice.call(descriptionEl.children);
    var detailsIndex = children.findIndex(function (el) {
      return el.textContent.trim().toLowerCase().replace(/:$/, '') === 'details';
    });

    if (detailsIndex !== -1) {
      var summaryText = children[detailsIndex].textContent.trim();
      var toggle = document.createElement('details');
      toggle.className = 'product-description__details';
      var summary = document.createElement('summary');
      summary.textContent = summaryText;
      toggle.appendChild(summary);

      // Skip the "Details" line itself (index detailsIndex) — its text is
      // now the <summary>, so re-inserting it too would duplicate it.
      children.slice(detailsIndex + 1).forEach(function (el) {
        toggle.appendChild(el);
      });

      children[detailsIndex].remove();
      descriptionEl.appendChild(toggle);
    }
  }

  var variantIdInput = document.querySelector('[data-variant-id]');
  if (!variantIdInput) return;

  var variantsEl = document.querySelector('[data-product-variants]');
  var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

  var optionGroups = document.querySelectorAll('[data-option-index]');
  var selected = [];

  optionGroups.forEach(function (group) {
    var activeButton = group.querySelector('.active');
    var index = parseInt(group.getAttribute('data-option-index'), 10);
    selected[index] = activeButton ? activeButton.getAttribute('data-option-value') : null;

    group.querySelectorAll('[data-option-value]').forEach(function (button) {
      button.addEventListener('click', function () {
        group.querySelectorAll('[data-option-value]').forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('active');
        button.setAttribute('aria-pressed', 'true');
        selected[index] = button.getAttribute('data-option-value');
        updateVariant();
      });
    });
  });

  function findMatchingVariant() {
    return variants.find(function (variant) {
      return variant.options.every(function (value, i) {
        return value === selected[i];
      });
    });
  }

  function setActiveMedia(mediaId) {
    if (!mediaId) return false;
    var slides = document.querySelectorAll('.product-gallery__slide');
    var matched = false;
    slides.forEach(function (slide) {
      if (slide.getAttribute('data-media-id') === String(mediaId)) {
        slide.hidden = false;
        slide.classList.add('active');
        matched = true;
      } else {
        slide.hidden = true;
        slide.classList.remove('active');
      }
    });
    if (matched) {
      document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        var isMatch = thumb.getAttribute('data-media-id') === String(mediaId);
        thumb.classList.toggle('active', isMatch);
      });
    }
    return matched;
  }

  function updateVariant() {
    var variant = findMatchingVariant();
    var priceEl = document.querySelector('[data-product-price]');
    var addButton = document.querySelector('[data-add-to-cart]');

    if (!variant) {
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = addButton.getAttribute('data-label-sold-out');
      }
      return;
    }

    variantIdInput.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price;

    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available
        ? addButton.getAttribute('data-label-available')
        : addButton.getAttribute('data-label-sold-out');
    }

    setActiveMedia(variant.media_id);
  }

  var thumbs = document.querySelectorAll('[data-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      setActiveMedia(thumb.getAttribute('data-media-id'));
    });
  });
});
